import React from "react"
import { Typography, Skeleton } from "@mui/material"
import { PricingOuter, PricingTitle, TotalCost, FindOut, PrePurchase } from "./styles"

function StandardPricing({ loading, cost, responses, costPerResponse, error }) {

	return (
		<PricingOuter>
			{!(error && Object.keys(error).length !== 0) ? 
				<div>
					<PricingTitle>
						{loading ? <Skeleton /> : "How much your target audience will cost"}
					</PricingTitle>
					<div>
						{loading ? <Skeleton /> : "Estimate the cost per response based on your target audience."}
					</div>
				</div>
			 : 
				null
			}

			

			{!(error && Object.keys(error).length !== 0) ? 
				<div>

				<TotalCost>{loading ? <Skeleton /> : `${costPerResponse}`}</TotalCost>

				<div style={{ marginBottom: 60}}>{loading ? <Skeleton /> : `per response.`}</div>
				<div style={{  margin: '0 0 70px'}}>{loading ? <Skeleton /> : `Total cost of ${cost} for ${responses} responses.`}</div>
			

				<PrePurchase>Pre purchase and save up to 20%</PrePurchase>
				
				</div> 
				:
				<div>
					<Typography variant='h5' gutterBottom>
						Not Available
					</Typography>
					<Typography variant='body1' gutterBottom>
						{error.message}
					</Typography>
				</div>
			}
		</PricingOuter>
	)
}

export default StandardPricing


// <FindOut>
// <a href="https://www.onepulse.com" target="_blank" rel="noreferrer">
// Find out how we calculate a price
// </a>
// </FindOut>